import { makeRequest } from 'utils/requestLogger';

export default (participationID) =>
  makeRequest('get', `/api/participations/${participationID}/summary`);



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/studentSummaryLD.js